/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { signUp } from "../../actions/authActions";
import Layout from "../layout/Layout";


const button = css`
  background-color: #f7c02d;
  border: none;
  outline: none;
  width: 110px;
  height: 40px;
  border-radius: 3px;
  margin-top: 20px;
  &:hover {
    cursor: pointer;
    color: #fff;
    transition: all 0.3s;
    border: 1px solid #fff;
  }
`;

class SignUp extends Component {
  state = {
    email: "",
    password: "",
    firstName: "",
    lastName: ""
  };

  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.signUp(this.state);
  };

  render() {
    if (this.props.auth.uid) return <Redirect to="/" />;

    return (
      <Layout noLinks={true}>
        <div
          css={css`
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 90vh;
            padding: 20px 0;
            & form {
              width: 270px;
            }
          `}
        >
          <form onSubmit={this.handleSubmit}>
            <h5 className="mb-4 text-center">Регистрация</h5>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                className="form-control"
                type="email"
                required
                id="email"
                onChange={this.handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Пароль</label>
              <input
                className="form-control"
                type="password"
                required
                id="password"
                minLength={6}
                onChange={this.handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="firstName">Имя</label>
              <input
                className="form-control"
                type="text"
                required
                id="firstName"
                onChange={this.handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="lastName">Фамилия</label>
              <input
                className="form-control"
                type="text"
                required
                id="lastName"
                onChange={this.handleChange}
              />
            </div>
            <button
              css={button}
              type="submit"
              className="d-block mx-auto mt-4"
            >
              подтвердить
            </button>
            <p className="text-center text-danger mt-3">
              {this.props.authError === "auth/invalid-email"
                ? "Некорректно введен e-mail"
                : this.props.authError === "auth/email-already-in-use"
                ? "Этот e-mail адрес уже используется"
                : this.props.authError === "auth/weak-password"
                ? "Пароль не меньше 6 символов"
                : null}
            </p>
          </form>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    authError: state.auth.authError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    signUp: newUser => dispatch(signUp(newUser))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUp);
